export default function sort(arr, fn) {
  return [...arr].sort(fn);
}



// WEBPACK FOOTER //
// ./src/sort.js